import { Divider, Icons, Input, Modal, ModalClose, ModalDialog, Sheet, Table, Typography } from '@healthinal/ui';
import { useState } from 'react';
import { useGetCountries } from '../../../api/generated/locale-controller/locale-controller.ts';

export function ShowCountryCodesDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { data: countries } = useGetCountries();
  const [searchText, setSearchText] = useState('');

  const filteredCountries = countries?.filter(
    (country) =>
      country.name.toLowerCase().includes(searchText.toLowerCase()) ||
      country.isoCode.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handleOnClose = () => onClose();

  return (
    <Modal open={open} onClose={handleOnClose}>
      <ModalDialog sx={{ width: 500 }}>
        <ModalClose />
        <Typography level={'h4'}>ISO-Ländercodes</Typography>
        <Divider />
        <Input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder={'Land suchen'}
          endDecorator={<Icons.Search />}
          sx={{ my: 1 }}
        />
        <Sheet sx={{ maxHeight: 400, overflow: 'auto' }}>
          <Table stickyHeader>
            <thead>
              <tr>
                <th style={{ width: 100 }}>ISO-Code</th>
                <th>Land</th>
              </tr>
            </thead>
            <tbody>
              {filteredCountries?.map((country) => (
                <tr key={country.isoCode}>
                  <td>{country.isoCode}</td>
                  <td>{country.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Sheet>
      </ModalDialog>
    </Modal>
  );
}
